import styled from 'styled-components';
// css书写规范：定位/显示 > 盒模型 > 排版 > 外观 > mixin
const Root = styled.div `
  .ant-input-search-button {
      padding-left: 10px;
      padding-right: 10px;
  }
  .search--result, .checkBox--result {
      margin: 10px;
  }
  .check--all {
    margin: 10px 0 0 20px;
  }
  .checkBox--result {
      padding: 10px;
      max-height: 140px;
      overflow: scroll;
      text-align: left;
      .ant-checkbox-group-item{
        width: 95%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
  }
  .checkBox--choose {
      padding: 0 20px;
      width: 100%;
      text-align: left;
      .ant-checkbox-group-item {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 10px;
      }
  }
  .search__container {
    width: 220px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .choose__title {
    padding: 10px 0;
    font-weight: 700;
    text-align: left;
    border-top: 1px solid #e5e5e5;
  }
  p {
      margin: 0;
  }
  .relative {
      position: relative;
  }
  .com_t {
      padding-left: 10px;
  }
  .flex__row-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;
const Tip = styled.p `
    padding: 10px;
    color: #bfbfbf;
`;
const ErrorTip = styled.p `
    padding: 10px;
    color: #f5222d;
`;
const PreIcon = styled.i `
    position: absolute;
    top: 50%;
    left: 2px;
    transform:translateY(-50%);
    content: '';
    width: 2px;
    height: 15px;
    border-radius: 1px;
    background: #bfbfbf;
`;
export { Root, Tip, ErrorTip, PreIcon };
